/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { useForm } from "react-hook-form";
import TableHeadingTitle from "../../../../shared/TableHeadingTitle/TableHeadingTitle";
import { PrimaryButton } from "../../../../shared/Buttons/Buttons";
import Modal, { ModalBody, ModalHeader } from "../../../../shared/Modals/Modal";
import TextField from "../../../../shared/Inputs/TextField/TextField";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";

import { formOptions } from "./PagecoursesPriceHelper";
import {
  addorUpdatePagecoursePrice,
  loadCoursePrice,
} from "../../../../store/features/AdminPanel/CoursePrice/CoursesPriceApi";
import {  setShowPageCoursePriceModal, setSinglePageCoursePrice } from "../../../../store/features/AdminPanel/CoursePrice/CoursesPriceSlice";
import SelectDropDown from "../../../../shared/SelectDropDown/SelectDropDown";
import ErrorText from "../../../../shared/Inputs/ErrorText/ErrorText";
import { AAPagePrice } from "./helper";

const PageCoursesPriceHeader = (props: any) => {
  const [showModal, setShowModal] = useState(false);

  const [selectedValue, setSelectedValue] = useState<any>(AAPagePrice[0]);
  const editor = useRef(null);
  const [content, setContent] = useState("");

  const dispatch = useAppDispatch();
  const coursePriceState = useAppSelector(
    (store: RootStore) => store.CoursesPriceSlice
  );
  const themeState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });

  useEffect(() => {
    dispatch(loadCoursePrice({type:selectedValue.value}));
  }, []);
  
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<any>(formOptions);

  const clearForm = ()=>{
    reset();
    setContent("");
    dispatch(setSinglePageCoursePrice())
  }

  const onSubmit = (values: any) => {
    const data = {
      ...values,
      description: content,
      type: selectedValue.value,
      id:coursePriceState?.single_page_course_price?.[0]?.id || null
    };
    // console.log("data::",data)
    dispatch(addorUpdatePagecoursePrice({ data })).then(()=>{
      clearForm()
    });
  };
  const onError = (error: any) => {
    console.log("ERROR:::", error);
  };

  const editorConfig: any = useMemo(
    () => ({
      readonly: false,
      height: "300px",
      width: "100%",
      buttons: [
        "source",
        "|",
        "bold",
        "italic",
        "underline",
        "|",
        "ul",
        "ol",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        "table",
        "link",
        "|",
        "left",
        "center",
        "right",
        "justify",
        "|",
        "undo",
        "redo",
        "|",
        "hr",
        "eraser",
        "fullsize",
      ],
      removeButtons: [
        "brush",
        "file",
        "eraser",
        "hr",
        "redo",
        "undo",
        "justify",
        "right",
        "center",
        "justify",
        "left",
        "link",
        "table",
        "image",
        "paragraph",
        "brush",
        "fontsize",
        "font",
        "source",
        "fullsize",
        "|",
      ],
      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: true,
      toolbarAdaptive: false,
      toolbarSticky: false,
      spellcheck: true,
      theme: themeState.themeMode === "dark" ? "dark" : "default",
      i18n: "en",
      // limitWords: 3,
      // autofocus: true,
      // cursorAfterAutofocus: "end",
      // saveSelectionOnBlur: true,
      style: {
        fontFamily: "Montserrat !important",
        textAlign: "justify",
      },
    }),
    []
  );

  const closeModalOnCrossIconClick = () => {
    dispatch(setShowPageCoursePriceModal(false));
    setShowModal(false);
    clearForm()
  };

  useEffect(() => {
    if (coursePriceState?.showPageCoursePriceModal) {
      setShowModal(true);
      setValue("name", coursePriceState.single_page_course_price[0]?.name);
      setValue("price", coursePriceState.single_page_course_price[0]?.price);
      setContent( coursePriceState.single_page_course_price[0]?.description)
     
    }
  }, [coursePriceState?.showPageCoursePriceModal]);

  useEffect(() => {
    if (!coursePriceState?.loading.add && coursePriceState?.req_success.add) {
      closeModalOnCrossIconClick();
      dispatch(loadCoursePrice({type:selectedValue.value}));
    }
  }, [!coursePriceState?.loading.add , coursePriceState?.req_success.add]);

  useEffect(() => {
    if (!coursePriceState?.loading.delete && coursePriceState?.req_success.delete) {
      dispatch(loadCoursePrice({type:selectedValue.value}));
    }
  }, [coursePriceState?.loading.delete , coursePriceState?.req_success.delete]);

  const handleOption = (data: any) => {
    setSelectedValue(data);
    dispatch(loadCoursePrice({type:data.value}));
  };
// console.log(selectedValue,coursePriceState?.single_page_course_price);
  return (
    <div className="header_container">
      <div className="left__section">
        <TableHeadingTitle>Courses Price</TableHeadingTitle>
        <div className="dropdown__holder">
          <SelectDropDown
            data={
              AAPagePrice
            }
            selectedValue={selectedValue.name}
            handleOption={handleOption}
          />
        </div>
      </div>
      <div className="right__section">
        <div className="button__witdh">
          <PrimaryButton
            text="Add New"
            size="sm"
            type="button"
            loading={false}
            onClick={() => setShowModal(true)}
          />
        </div>
      </div>

      <Modal
        show={showModal}
        setShow={setShowModal}
        onClick={closeModalOnCrossIconClick}
      >
        <ModalHeader title={coursePriceState?.showPageCoursePriceModal ? "Update Course Price" : "Add Course Price"} />
        <ModalBody>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="width__for__title">
              {" "}
              <TextField
                type="text"
                label="Title"
                name="name"
                register={register}
                // error={errors?.title}
              />
            </div>
            <div className="form_row">
              <TextField
                type="number"
                label={`Price ${coursePriceState?.single_page_course_price?.[0]?.name ? `of ${coursePriceState.single_page_course_price[0].name} ` : ""}($)`}
                name="price"
                register={register}
                error={errors?.price}
              />
            </div>
            <span className="description__title"> Description</span>
            <div className="editor__wrapper">
              <JoditEditor
                ref={editor}
                value={content}
                config={editorConfig}
                onBlur={(newContent) => setContent(newContent)}
              />
              {/* <ErrorText error={errorMessage} /> */}
            </div>

            <div className="button__witdh mt-1">
              <PrimaryButton
                text={coursePriceState?.showPageCoursePriceModal ?"Update" :"Add"}
                type="submit"
                loading={
                  coursePriceState?.loading.add && !coursePriceState?.req_success.add
                }
              />
            </div>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default PageCoursesPriceHeader;
